import { useState } from 'react';
import { Provider } from '@adobe/react-spectrum';
import { nanoid } from 'nanoid';
import { themeDHDefault } from "../spectrum/utils/index.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Wrapper around React Spectrum's theme Provider that provides DH mappings of
 * Spectrum's theme variables to DH's theme variables. Also exposes an optional
 * `isPortal` prop that if provided, adds a unique `data-unique-id` attribute to
 * the Provider. This is needed to force the Provider to render the theme wrapper
 * inside of portals.
 */
export function SpectrumThemeProvider(_ref) {
  var {
    children,
    isPortal = false,
    theme = themeDHDefault,
    colorScheme,
    zIndex,
    position
  } = _ref;
  // a unique ID is used per provider to force it to render the theme wrapper element inside portals
  // based on https://github.com/adobe/react-spectrum/issues/1697#issuecomment-999827266
  // won't be needed if https://github.com/adobe/react-spectrum/pull/2669 is merged
  var [id] = useState(isPortal ? nanoid() : null);
  return /*#__PURE__*/_jsx(Provider, {
    UNSAFE_className: "spectrum-theme-provider",
    theme: theme,
    colorScheme: colorScheme,
    zIndex: zIndex,
    position: position,
    "data-unique-id": id,
    children: children
  });
}
//# sourceMappingURL=SpectrumThemeProvider.js.map